<mat-card>
	<div class="text-center h4 margin-top-lg">
		There is {{data.OTHER_SESSIONS_ACTIVE }} other session(s) active
	</div>

	<hr />
	<mat-card-content class="text-center">
		<h3>Only {{data.MAX_SESSIONS_ALLOWED}} session(s) is allowed to be active.
		</h3>
		<h3>You must remove the other sesion to continue.</h3>
		<h4>* Other sessions will be logged out.</h4>
		<button mat-raised-button color="primary" (click)="removeOtherSessions()" [disabled]="isLoading">Remove other
			sessions</button>
	</mat-card-content>
	<hr />

	<mat-dialog-actions align="end">
		<button mat-raised-button color="warn" (click)="logout()" [disabled]="isLoading">Logout</button>
	</mat-dialog-actions>
</mat-card>